export const PAGE_TITLE_SUFFIX = 'OpenClassrooms';
export const PAGE_TITLE_B2B_SUFFIX = 'OpenClassrooms for Business';
export const PAGE_TITLE_SEPARATOR = ' - ';
